import * as Objdict from "objdict"

import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

import {getImageFromAnimation} from "./utility/animation.js"
import timer from "@frog/source/views/app/stage/utility/timer.js"
import pixel from "@frog/source/views/app/stage/utility/pixel.js"

import Random from "@frog/source/utility/Random.js"
import Colors from "@frog/source/data/colors.js"

export default function Units(stage) {
    return Object.values(stage.units).map((unit, index) => {
        if(unit.isDead == true) return
        return {
            "key": "Unit/" + unit.key,
            "type": "container",
            "position": UnitPositionAnimations(stage, unit),
            "children": [
                {
                    "key": "Sprite",
                    "position": {"stack": 1},
                    "image": UnitImage(stage, unit, index),
                    // "direction": unit.affiliation == "good" ? "left" : "right",
                    "outline": UnitOutline(stage, unit),
                    "grayscale": UnitGrayscale(stage, unit),
                    "opacity": unit.opacity != undefined ? unit.opacity : undefined,
                    "rotation": unit.rotation,
                    "width": unit.width,
                    "height": unit.height,
                },
                // {
                //     "key": "Shadow",
                //     "position": {"stack": 0},
                //     "image": require("@frog/source/assets/images/cryptid-tactics/units/dropshadow.png"),
                // },
                // HealthBar(stage, unit),
                // TrapTiles,
                // ElementalMark,
            ]
        }
    })
}

import protounits from "@frog/source/data/units.js"
function UnitImage(stage, unit, index = 0) {
    if(unit.image != undefined) {
        return unit.image
    }

    const protounit = protounits[unit.reference]
    if(protounit == undefined
    || protounit.images == undefined
    || protounit.images.sprites == undefined) {
        return
    }

    if(protounit.images.sprites.idle != undefined) {
        return getImageFromAnimation(protounit.images.sprites.idle, timer.ms + (index * 100))
    }

    if(protounit.images.sprites.static != undefined) {
        return protounit.images.sprites.static
    }
}

function UnitOutline(stage, unit) {
    if(Director.isPerforming == true) return
    if(unit.key == undefined) return
    if(App.game.encounter.selection.selectedUnitKey == unit.key) {
        return {"thickness": 1, "color": Colors.white}
    }
    if(App.game.encounter.selection.hoveredUnitKey == unit.key) {
        return {"thickness": 1, "color": Colors.yellow}
    }
}

function UnitGrayscale(stage, unit) {
    if(unit.transform != undefined
    && unit.transform.grayscale != undefined) {
        return unit.transform.grayscale
    }
    if(unit.energy["move"] == false
    && unit.energy["invoke skill"] == false) {
        return 0.4
    }
    return 0
}

function UnitPositionAnimations(stage, unit) {
    const position = pixel("unit", UnitPosition(stage, unit))
    if(unit.reference == "bomb") {
    // && unit.effects["fuse"] != undefined
    // && unit.effects["fuse"].timer <= 1) {
        position.x += Random.range(-1, 1)
        position.y += Random.range(-1, 1)
    }
    return position
}

function UnitPosition(stage, unit) {
    // Rendering the unit position as
    // the future state of the actions.
    if(Director.isPerforming != true
    && App.game.encounter != undefined
    && App.game.encounter.selection != undefined
    && App.game.encounter.selection.hoveredAction != undefined
    && App.game.encounter.selection.hoveredAction.omegastage != undefined
    && App.game.encounter.selection.hoveredAction.omegastage[unit.key] != undefined) {
        const omegaunit = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
        return omegaunit.position
    }
    const position = {
        "x": unit.position.x,
        "y": unit.position.y,
        "z": unit.position.z,
    }
    if(unit.transform != undefined
    && unit.transform.position != undefined) {
        position.x += unit.transform.position.x || 0
        position.y += unit.transform.position.y || 0
        position.z += unit.transform.position.z || 0
    }
    return position
}

// let healthbarsprite = HealthBar(unit.key, health, unit.maxhealth, {"x": 0, "y": 0, "z": 0}, unit.affiliation, unitForEndangeredHealth)
function HealthBar(stage, unit) {
    if(unit.opacity != undefined) {
        return
    }
    // // Rendering the unit position as
    // // the future state of the actions.
    // if(Director.isPerforming != true
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.hoveredAction != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage[unit.key] != undefined) {
    //     unit = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
    // }
    // if(Director.isPerforming != true
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.activeUnit != undefined
    // && App.game.encounter.selection.activeUnit.affiliation == "bad"
    // && stage.nextTurn != undefined
    // && stage.nextTurn.omegastage != undefined
    // && stage.nextTurn.omegastage.units[unit.key] != undefined) {
    //     unit = stage.nextTurn.omegastage.units[unit.key]
    //     // TODO: This is showing the entire enemy turn omegastage
    //     // instead of just what damage will be performed by this
    //     // hovered enemy unit. Can we get that granular?
    // }
    // THIS RENDERS JUST THE NEXT ACTION'S OUTCOME
    // if(Director.isPerforming != true
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.hoveredAction != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.units[unit.key] != undefined) {
    //     unitForEndangeredHealth = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
    // }
    // THIS RENDERS THE NEXT TURN'S HEALTH OUTCOME, BUT
    // CURRENTLY RENDERS IT LIKE IT IS THE ACTUAL HEALTH
    let nextTurnUnit = undefined
    if(Director.isPerforming != true
    && stage.nextTurn != undefined
    && stage.nextTurn.omegastage != undefined
    && stage.nextTurn.omegastage.units[unit.key] != undefined) {
        nextTurnUnit = stage.nextTurn.omegastage.units[unit.key]
    }
    if(Director.isPerforming != true
    && App.game.encounter != undefined
    && App.game.encounter.selection != undefined
    && App.game.encounter.selection.hoveredAction != undefined
    && App.game.encounter.selection.hoveredAction.omegastage != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.nextTurn != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units[unit.key] != undefined) {
        nextTurnUnit = App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units[unit.key]
    }

    let health = unit.health
    if(unit.transform != undefined
    && unit.transform.health != undefined) {
        health += unit.transform.health
    }

    let endangeredHealth = undefined
    if(nextTurnUnit != undefined) endangeredHealth = nextTurnUnit.health

    const sprites = []
    const WIDTH = 1
    const HEIGHT = 2
    const GAP = 0
    for(let i = 0; i < unit.maxhealth; i += 1) {
        const x = (i * WIDTH) + (i != 0 ? i * GAP : 0)
        if(i >= health) {
            sprites.push({
                "key": "health/" + i,
                "anchor": {"x": 0, "y": 0},
                "position": {"x": x, "y": 0, "stack": 0},
                // "image": require("@frog/source/assets/images/cryptid-tactics/healthbar-hurt.png"),
                "type": "rectangle",
                "color": Colors.white,
                "width": WIDTH,
                "height": HEIGHT,
            })
        } else if(i >= endangeredHealth) {
            sprites.push({
                "key": "health/" + i,
                "anchor": {"x": 0, "y": 0},
                "position": {"x": x, "y": 0, "stack": 0},
                // "position": {"x": x, "y": (Math.floor(Math.random() * 2) - 1), "stack": 0},
                // "image": require("@frog/source/assets/images/cryptid-tactics/healthbar-threatened.png"),
                "type": "rectangle",
                "color": Colors.yellow,
                "width": WIDTH,
                "height": HEIGHT,
            })
        } else {
            // let image = require("@frog/source/assets/images/cryptid-tactics/healthbar-healthy.png")
            // if(unit.affiliation == "good") {
            //     image = require("@frog/source/assets/images/cryptid-tactics/healthbar-healthy-good.png")
            // }
            sprites.push({
                "key": "health/" + i,
                "anchor": {"x": 0, "y": 0},
                "position": {"x": x, "y": 0, "stack": 0},
                // "image": image,
                "type": "rectangle",
                "color": Colors.red, // TODO: color differently for allies
                "width": WIDTH,
                "height": HEIGHT,
            })
        }
    }
    return {
        "key": "healthbar",
        "position": {
            "x": ((WIDTH * unit.maxhealth) / -2) + (WIDTH / 2),
            "y": HEIGHT * 0,
            "stack": 100000000
        },
        "children": sprites
    }
}

// import elements from "@frog/source/data/elements.js"
// function ElementalMark() {
//     // let elementsprite = undefined
//     // if(Director.isPerforming != true
//     // && (App.game.encounter.selection.selectedUnitKey == unit.key
//     // || App.game.encounter.selection.hoveredUnitKey == unit.key)) {
//     //     const element = elements[unit.element]
//     //     let isInDanger = false
//     //     if(App.game.encounter.selection.hoveredUnitKey == unit.key
//     //     && App.game.encounter.selection.selectedUnitKey != undefined
//     //     && App.game.encounter.selection.selectedUnit.isDead != true
//     //     && App.game.encounter.selection.hoveredUnit.isDead != true
//     //     && App.game.encounter.selection.selectedUnitKey != App.game.encounter.selection.hoveredUnitKey
//     //     && App.game.encounter.selection.selectedUnit.affiliation != App.game.encounter.selection.hoveredUnit.affiliation
//     //     && element != undefined
//     //     && element.weaknesses.includes(App.game.encounter.selection.selectedUnit.element)) {
//     //         isInDanger = true
//     //     }
//     //     if(App.game.encounter.selection.selectedUnitKey == unit.key
//     //     && App.game.encounter.selection.hoveredUnitKey != undefined
//     //     && App.game.encounter.selection.selectedUnit.isDead != true
//     //     && App.game.encounter.selection.hoveredUnit.isDead != true
//     //     && App.game.encounter.selection.selectedUnitKey != App.game.encounter.selection.hoveredUnitKey
//     //     && App.game.encounter.selection.selectedUnit.affiliation != App.game.encounter.selection.hoveredUnit.affiliation
//     //     && element != undefined
//     //     && element.weaknesses.includes(App.game.encounter.selection.hoveredUnit.element)) {
//     //         isInDanger = true
//     //     }
//     //     if(element != undefined
//     //     && element.icon != undefined) {
//     //         elementsprite = {
//     //             "key": "unit/" + unit.key + "/element",
//     //             "image": element.icon,
//     //             "position": pixel("elemental-icon", {
//     //                 "x": position.x + (isInDanger ? Math.random() * 0.1 : 0),
//     //                 "y": position.y + (isInDanger ? Math.random() * 0.1 : 0),
//     //                 "z": position.z + 0.6,
//     //             }),
//     //             // "scale": {"x": 1, "y": 0.5},
//     //         }
//     //     }
//     // }
// }

// // const trapSprites = TrapSprites(omegaunit || unit)
// function TrapSprites(unit) {
//     const sprites = []
//     if(unit.effects != undefined) {
//         Objdict.forEach(unit.effects, (effect, effectKey) => {
//             if((effect.type == "trap" || effect.type == "traplike")
//             && effect.positions != undefined) {
//                 effect.positions.forEach((position, index) => {
//                     sprites.push({
//                         "key": "unit/traps/" + effectKey + "/" + index,
//                         "image": require("@frog/source/assets/images/bomber-tactics/shout-tileset/tile-threat.png"),
//                         "position": pixel("dangerzone", position),
//                     })
//                 })
//             }
//         })
//     }
//     return sprites
// }
